<template>
	<div class="WallInfo">
		<h3>General Info</h3>
		<ul>
			<li>Id: {{$route.params.clientId}}</li>
			<li>User Friendly Name: </li>
			<li>URL: <router-link :to="{name:'PrayerWall', params: {clientId: $route.params.clientId}}">Link</router-link></li>
		</ul>
		<!--
		<h3>Active Integrations</h3>
		<ul>
			<li>Integration 1</li>
		</ul>
	-->
	</div>
</template>

<script setup>

</script>
